import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldBreak: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconShieldBreak"><Path d="M3.75 5.75V13C3.75 17.5563 7.44365 21.25 12 21.25C14.8328 21.25 17.3321 19.8223 18.8176 17.6471M7 4.37121L10.8284 2.74706C11.5772 2.42939 12.4228 2.42939 13.1716 2.74706L18.4216 4.97434C19.5301 5.44459 20.25 6.532 20.25 7.73608V13C20.25 13.6049 20.1849 14.1945 20.0613 14.7624M1.75 3.75L22.25 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconShieldBreak;
